<template>
  <div>{{ count }}</div>
</template>

<script>
  export default {
    data: function () {
      return {
        count: 0
      }
    },
    mounted () {
      console.log('Vue tl-test, ready')
      this.start_update()
    },
    beforeDestroy () {
      console.log('Vue tl-test, beforeDestroy')
      this.stop_update()
    },
    methods: {
      start_update: function () {
        this.timer = setInterval(this.update, 5000)
      },
      stop_update: function () {
        clearInterval(this.timer)
      },
      update: function () {
        this.count++
        console.log('still counting')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// TlTest.vue?1a8e1770